import React from 'react';
import { StreamSource } from '../services/api';

// ---------------------------------------------------------------------------
// Helpers
// ---------------------------------------------------------------------------

/** 按 url/bvid/title 去重，保留首次出现的顺序。 */
export function dedupeSources(list: StreamSource[]): StreamSource[] {
  const seen = new Set<string>();
  const out: StreamSource[] = [];
  for (const s of list || []) {
    if (!s) continue;
    const key = s.url || s.bvid || s.title;
    if (key && !seen.has(key)) {
      seen.add(key);
      out.push(s);
    }
  }
  return out;
}

// ---------------------------------------------------------------------------
// SourceItem：精简纯标题+外部直达链接（named export，供回答气泡内联折叠块复用）
// ---------------------------------------------------------------------------

export const SourceItem: React.FC<{ source: StreamSource; index: number }> = ({ source: s, index }) => {
  const url = s.url || (s.bvid ? `https://www.bilibili.com/video/${s.bvid}` : '#');
  return (
    <a
      href={url}
      target="_blank"
      rel="noopener noreferrer"
      className="source-link-item"
      title={s.title}
    >
      <span className="source-link-index">{index + 1}</span>
      <span className="source-link-title">{s.title}</span>
      <span className="source-link-icon">↗</span>
    </a>
  );
};
